/* src/app/admin-setting/email/email.component.css */
.header-color {
  background-color: var(--custom-color);
  color: white;
}
/*# sourceMappingURL=email.component.css.map */
